import React, { Component } from 'react';
import { View, Button, Text, Link, ConfirmationCodeInput } from 'core';
import * as actions from 'actions';
import { style, theme, COUNTRIES } from 'constants';
import { lang } from 'lang';
import { IcoBack } from 'icons';

const styles = style({
  container: {
    //flex: 1,
    alignItems: 'center'
  },
  back: {
    alignSelf: 'stretch',
    alignItems: 'flex-start',
    marginVertical: 30
  },
  text: {
    textAlign: 'center',
    color: theme.primary_color
  },
  btn: {
    marginTop: 25
  }
});

class Verify extends Component {
  state = {
    code: ''
  };
  _getTelCode = country_code => (COUNTRIES[country_code] && COUNTRIES[country_code].tel) || 966;
  _verify = () => {
    const { account, country_code, action } = this.props;
    const { code } = this.state;
    action({ account, tel_code: this._getTelCode(country_code), code });
  };
  render() {
    const { country_code, use_phone, account, back, index, status, onSuccess } = this.props;
    const { code } = this.state;
    const tel_code = this._getTelCode(country_code);

    return (
      <View style={styles.container}>
        <Link style={styles.back} size={18} icon={IcoBack} title={lang.BACK} onPress={back} selected />

        <Text style={[styles.text, { fontSize: 16 }]}>{lang.VERIFICATION_SENT}</Text>
        <Text style={[styles.text, { fontSize: 24, marginBottom: 25, marginTop: 5 }]}>{use_phone ? '+' + tel_code + account : account}</Text>
        <ConfirmationCodeInput
          key={`authCode${index === 2}`}
          codeLength={4}
          keyboardType="number-pad"
          className="border-circle"
          onChangeText={code => this.setState({ code })}
          autoFocus={index === 2}
          activeColor={theme.primary_color}
          inactiveColor={theme.gray_color_lighten(0.2)}
          onFulfill={code => this.setState({ code }, this._verify)}
        />
        <Button status={status} onSuccess={onSuccess} style={styles.btn} title={lang.VERIFY} onPress={this._verify} disabled={code.trim().length !== 4} />
      </View>
    );
  }
}
export default Verify;



// WEBPACK FOOTER //
// ./src/components/login/verfiy.js